import Vue from "vue";
import * as fmt from "@/utils/fmt.js";

Vue.config.productionTip = false;
Vue.config.performance = true;

import "./plugins";

import pinia from "./stores/index";
import { router } from "./routes";

import "./styles/main.scss";

import App from "./App.vue";
import { checkAppVersion, startAppVersionPolling } from "@/services/version";

Vue.filter("euro", fmt.euro);
Vue.filter("fraction", fmt.fraction);
Vue.filter("dateEs", fmt.date);

new Vue({ router, pinia, render: (h) => h(App) }).$mount("#app");

checkAppVersion({ force: true });
startAppVersionPolling();
